import { render, staticRenderFns } from "./CreateProcessStatusRuleModal.vue?vue&type=template&id=72434bb0"
import script from "./CreateProcessStatusRuleModal.vue?vue&type=script&lang=js"
export * from "./CreateProcessStatusRuleModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports